const $oldDetailNews = $('.article__body--old');

if ($oldDetailNews.length) {
	$oldDetailNews
		.find('p')
		.each(function(index, el) {
			if ($(el).find('em').length) {
				$(el).addClass('note');
			}
		});

	$oldDetailNews
		.find('table')
		.each(function(index, el) {
			if (!$(el).parent('div').hasClass('table')) {
				$(el).wrap(`<div class="table"></div>`);
			}
		});

	$oldDetailNews
		.find('ul')
		.each(function(index, el) {
			if (!$(el).parent('i').length) {
				$(el).wrap(`<div class="ul-wrapper"></div>`);
			} else {
				$(el)
					.parent('i')
					.addClass('ul-wrapper u-block')
			}
		});
}



// WEBPACK FOOTER //
// ./frontend/components/news/news.js